import React from 'react';
import { Typography } from '../Typography/Typography';
import styles from './EmptyStateButton.module.scss';

export interface EmptyStateButtonProps {
  label: string;
  onClick: () => void;
}

const EmptyStateButton = ({ label, onClick }: EmptyStateButtonProps) => {
  return (
    <div className={styles['dashed-container']} role="empty-state-button" onClick={onClick}>
      <Typography className={styles['text']} weight="semi-bold">
        {label}
      </Typography>
    </div>
  );
};

export default EmptyStateButton;
